export class TipoAsignacionConstants{
  static MATERNIDAD = 'Maternidad';
  static CARGA_FAMILIA = 'Cargas de familia';
}
